module.exports = __webpack_public_path__ + "918dcec411b7629704e10e11250e0151.pdf";